<template>
        <div>
            <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form role="form" class="mt-4">
                    <b-row>
                        <b-col md="8" cols="12">
                            <b-form-group label="Product Type">
                                <el-select v-model="select.product_type_id" placeholder="Select" @change="getPayoutDistributionSettingsData">
                                    <el-option
                                    v-for="item in product_types"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" v-for="form in forms" :key="form.lead_type_code">
                            <h4 v-if="form.lead_type_code == 'Personal'">Personal Lead</h4>
                            <h4 v-else-if="form.lead_type_code == 'Company'">Company Lead</h4>
                            <h4 v-else-if="form.datas.service_type_code == 'INSURANCE_INVESTMENT_LINKED_COMMISSION'">Investment Linked</h4>
                            <h4 v-else-if="form.datas.service_type_code == 'INSURANCE_LIFE_INSURARNCE_COMMISSION'">Life Insurance</h4>
                            
                            <b-row v-for="data in form.datas" :key="data.service_type_code">
                                <!-- {{ data.service_type_code }} -->
                                <b-col cols="6" v-if="data.service_type_code">
                                    <b-form-group :label="getLabelName(data.service_type_code)">
                                        <b-input-group append="%" v-if="data.settings">
                                            <b-form-input
                                                @keydown="preventNonNumericInput"
                                            v-model="data.settings.service_type_percentage"
                                            type="text"
                                            placeholder="Enter commitment percentage"
                                            ></b-form-input>
                                        </b-input-group>
                                        <b-input-group append="%" v-else>
                                            <b-form-input
                                                @keydown="preventNonNumericInput"
                                            v-model="data.service_type_percentage"
                                            type="text"
                                            placeholder="Enter commitment percentage"
                                            ></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col cols="12" v-if="payout_settings">
                            <b-table-simple bordered responsive class="border-dark">
                                <b-thead class="text-center">
                                    <b-tr class="bg-grey" v-if="current_hub">
                                        <b-th></b-th>
                                        <b-th class="text-right">Payout ({{ current_hub.revenue_distribution_settings.direct_payout_percentage }}%)</b-th>
                                        <b-th class="text-right">Pool ({{ current_hub.revenue_distribution_settings.pool_payout_percentage }}%)</b-th>
                                    </b-tr>
                                    <b-tr class="bg-grey" v-else>
                                        <b-th></b-th>
                                        <b-th class="text-right">Payout ({{ current_team.hub.revenue_distribution_settings.direct_payout_percentage }}%)</b-th>
                                        <b-th class="text-right">Pool ({{ current_team.hub.revenue_distribution_settings.pool_payout_percentage }}%)</b-th>
                                    </b-tr>
                                    <!-- <b-tr>
                                        <b-th class="border-right-0">RP Allocation (RM)</b-th>
                                        <b-th class="text-right border-right-0 border-left-0">{{8500 | moneyFormatter}}</b-th>
                                        <b-th class="text-right border-left-0">{{1500 | moneyFormatter}}</b-th>
                                    </b-tr> -->
                                </b-thead>
                                <b-tbody>
                                    <b-tr>
                                        <b-td rowspan="8">Payout Distribution (%)</b-td>
                                        <b-td class="flex-container">
                                            <span class="pr-3">T1: Mortgage Specialist (%)</span>
                                            <b-col>
                                                <b-form-input
                                                @keydown="preventNonNumericInput"
                                                v-model="payout_settings.T1_setting_percentage"
                                                type="text"
                                                placeholder="Enter commission percentage"
                                                ></b-form-input>
                                            </b-col>

                                            <!-- <span class="pl-1">{{ (8500 * payout_settings.T1_setting_percentage  / 100).toLocaleString() }}</span> -->
                                        </b-td>
                                        <b-td>
                                            <div class="flex-container">
                                                <span>P1: ({{ payout_settings.P1_setting_percentage }}%)</span> 
                                                <!-- <span>{{ (1500 * payout_settings.P1_setting_percentage / 100).toLocaleString() }}</span> -->
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="flex-container">
                                            <span class="pr-3">T2: Sales Manager (%)</span>
                                            <b-col>
                                                <b-form-input
                                                @keydown="preventNonNumericInput"
                                                v-model="payout_settings.T2_setting_percentage"
                                                type="text"
                                                placeholder="Enter commission percentage"
                                                ></b-form-input>
                                            </b-col>
                                            <!-- <span class="pl-1">{{ (8500 * payout_settings.T2_setting_percentage / 100).toLocaleString() }}</span> -->
                                        </b-td>
                                        <b-td class="text-center">
                                            <div class="flex-container">
                                                <span>P2: ({{ payout_settings.P2_setting_percentage }}%)</span>
                                                <!-- <span>{{ (1500 * payout_settings.P2_setting_percentage / 100).toLocaleString() }}</span> -->
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="flex-container">
                                            <span class="pr-3">T3: Hub Manager (%)</span>
                                            <b-col>
                                                <b-form-input
                                                @keydown="preventNonNumericInput"
                                                v-model="payout_settings.T3_setting_percentage"
                                                type="text"
                                                placeholder="Enter commission percentage"
                                                ></b-form-input>
                                            </b-col>
                                            <!-- <span class="pl-1">{{ (8500 * payout_settings.T3_setting_percentage / 100).toLocaleString() }}</span> -->
                                        </b-td>
                                        <b-td class="text-center">
                                            <div class="flex-container">
                                                <span>P3: ({{ payout_settings.P3_setting_percentage }}%)</span>
                                                <!-- <span>{{ (1500 * payout_settings.P3_setting_percentage / 100).toLocaleString() }}</span> -->
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="flex-container">
                                            <span class="pr-3">T4: Company (%)</span>
                                            <b-col>
                                                <b-form-input
                                                @keydown="preventNonNumericInput"
                                                v-model="payout_settings.T4_setting_percentage"
                                                type="text"
                                                placeholder="Enter commission percentage"
                                                ></b-form-input>
                                            </b-col>
                                            <!-- <span class="pl-1">{{ (8500 * payout_settings.T4_setting_percentage / 100).toLocaleString() }}</span> -->
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="flex-container">
                                            <span class="pr-3">T5: Mobile Specialist (%)</span>
                                            <b-col>
                                                <b-form-input
                                                @keydown="preventNonNumericInput"
                                                v-model="payout_settings.T5_setting_percentage"
                                                type="text"
                                                placeholder="Enter commission percentage"
                                                ></b-form-input>
                                            </b-col>
                                            <!-- <span class="pl-1">{{ (8500 * payout_settings.T5_setting_percentage / 100).toLocaleString() }}</span> -->
                                        </b-td>                                                    
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="flex-container">
                                            <span>R1: ({{ payout_settings.R1_setting_percentage }}%)</span>
                                            <!-- <span>{{ (8500 * payout_settings.R1_setting_percentage / 100).toLocaleString() }}</span> -->
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="flex-container">
                                            <span>R2: ({{ payout_settings.R2_setting_percentage }}%)</span>
                                            <!-- <span>{{ (8500 * payout_settings.R2_setting_percentage / 100).toLocaleString() }}</span> -->
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="flex-container">
                                            <span>R3: ({{ payout_settings.R3_setting_percentage }}%)</span>
                                            <!-- <span>{{ (8500 * payout_settings.R3_setting_percentage / 100).toLocaleString() }}</span> -->
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-col>

                        <b-col cols="8">
                            <b-button block variant="primary" class="w-50" @click.prevent="update()" :disabled="invalid">Save</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
        </div>
</template>
<script>
import { Drawer, Option, Select } from 'element-ui'
import EditHubDetailsModal from '@/views/Commission/Hub/HubProfile/HubModals/EditHubDetailsModal'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { axios, services, getHeader, swal } from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js';
import { useHubStore } from '@/stores/hubStore'
import { EventBus } from "@/main";

export default {
    mixins: [notifyFunctionMixin],
    components: {
        EditHubDetailsModal,
        ValidationObserver,
        ValidationProvider,
        [Drawer.name]: Drawer,
        [Option.name]: Option,
        [Select.name]: Select,
    },
    data() {
        return {
            drawerViewHubDirectPayoutSettings: false,
            hub_id: null,
            forms: {},
            payout_settings: {
                T1_setting_percentage: null,
                T2_setting_percentage: null,
                T3_setting_percentage: null,
                T4_setting_percentage: null,
                T5_setting_percentage: null,
                P1_setting_percentage: null,
                P2_setting_percentage: null,
                P3_setting_percentage: null,
                R1_setting_percentage: null,
                R2_setting_percentage: null,
                R3_setting_percentage: null,
            },
            select: {
                product_type_id: 1,
            },
            product_types: [
                {
                    value: 1,
                    label: 'Property Projects (KOHATA)'
                }, 
                {
                    value: 2,
                    label: 'Arrangement Fees (Sub-sale / Refinance / Personal Loans)'
                }, 
                {
                    value: 3,
                    label: 'Insurance Products'
                }, 
                {
                    value: 4,
                    label: 'Legal Marketeer Fees'
                },
            ],
        };
    },
    computed: {
        ...mapState(useHubStore,['current_hub', 'current_team']),
    },
    created() {
        if(this.$route.params.hub_id)
        {
            this.hub_id = this.current_hub.hub_id;
        }
        else if(this.$route.params.hub_team_id)
        {
            this.hub_id = this.current_team.hub.hub_id;
        }
        this.getPayoutDistributionSettingsData();
        EventBus.$on('refetch-payout-settings', this.refetchHub);
    },
    methods: {
        ...mapActions(useHubStore, ['getHub']),
        isNumber(value) {
            return !isNaN(value);
        },
        refetchHub() {
            return this.getHub(this.hub_id);
        },
        getPayoutDistributionSettingsData() {
            const query = '?hub_id=' + this.hub_id +'&product_id=' + this.select.product_type_id + '&hub_type_id=1';
            axios.get(services.hub + 'hub_comms/payout_distribution.show_by_hub_id_product_id' + query, {headers: getHeader()})
            .then(res  => {
                this.forms = res.data.data;
                if(res.data.data[0].datas[0])
                {
                    this.payout_settings = res.data.data[0].datas[0].settings;
                }
                else
                {
                    this.payout_settings = res.data.data[0].datas.settings;
                }
                this.notifySuccess('<b></b> - Successfully Obtained.')
            })
            .catch(e => {
                this.errorFunction(e, 'error')
            })
        },
        getLabelName(service_type_code) {
            switch(service_type_code)
            {
                case 'PERSONAL_PROPERTY_NO_ADVISORY_SERVICE':
                    return 'No Advisory Commitment Rate(%) - Green';
                case 'PERSONAL_PROPERTY_WITH_ADVISORY_SERVICE':
                    return 'With Advisory Commitment Rate(%) - Yellow';
                case 'COMPANY_PROPERTY_NO_ADVISORY_SERVICE':
                    return 'No Advisory Commitment Rate(%) - Green';
                case 'COMPANY_PROPERTY_WITH_ADVISORY_SERVICE':
                    return 'With Advisory Commitment Rate(%) - Yellow';
                case 'PERSONAL_ARRANGEMENT_FEE_NO_ADVISORY_SERVICE':
                    return 'No Advisory Commitment Rate(%) - Green';
                case 'PERSONAL_ARRANGEMENT_FEE_WITH_ADVISORY_SERVICE':
                    return 'With Advisory Commitment Rate(%) - Yellow';
                case 'COMPANY_ARRANGEMENT_FEE_NO_ADVISORY_SERVICE':
                    return 'No Advisory Commitment Rate(%) - Green';
                case 'COMPANY_ARRANGEMENT_FEE_WITH_ADVISORY_SERVICE':
                    return 'With Advisory Commitment Rate(%) - Yellow';
                case 'INSURANCE_INVESTMENT_LINKED_COMMISSION':
                    return 'Commission Rate(%)';
                case 'INSURANCE_LIFE_INSURARNCE_COMMISSION':
                    return 'Commission Rate(%)';
                case 'LEGAL_REFERRAL_FEE':
                    return 'Legal Fee Commiment Rate(%)';
            }
        },
        filterPayoutDistributions(settings) {
            settings.T1_setting_percentage = this.payout_settings.T1_setting_percentage;
            settings.T2_setting_percentage = this.payout_settings.T2_setting_percentage;
            settings.T3_setting_percentage = this.payout_settings.T3_setting_percentage;
            settings.T4_setting_percentage = this.payout_settings.T4_setting_percentage;
            settings.T5_setting_percentage = this.payout_settings.T5_setting_percentage;
            settings.P1_setting_percentage = this.payout_settings.P1_setting_percentage;
            settings.P2_setting_percentage = this.payout_settings.P2_setting_percentage;
            settings.P3_setting_percentage = this.payout_settings.P3_setting_percentage;
            settings.R1_setting_percentage = this.payout_settings.R1_setting_percentage;
            settings.R2_setting_percentage = this.payout_settings.R2_setting_percentage;
            settings.R3_setting_percentage = this.payout_settings.R3_setting_percentage;
            return settings;
        },
        update() {
            const filteredData = this.forms.map(item => {
                // const { lead_type_code, datas } = item;
                let settingDatas = {};
                if(Array.isArray(item.datas))
                {
                    settingDatas = item.datas.map(data => {
                        const { service_type_code, settings } = data;
                        this.filterPayoutDistributions(data.settings);
                        return data.settings;
                    });
                }
                else
                {
                    this.filterPayoutDistributions(item.datas.settings);
                    settingDatas = item.datas.settings;
                }
                
                return settingDatas;
            });

            axios.put(services.hub + 'hub_comms/payout_distribution/' + this.hub_id, filteredData, {headers: getHeader()})
            .then(res  => {
                this.notifySuccess('<b>Commission Settings Data</b> - Successfully Updated.')
            })
            .catch(e => {
                this.errorFunction(e, 'error')
            })

        },
    }
}
</script>
<style scoped>
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>